<template>
  <div class="crud_form_wrapper app_settings_class">
    <!-- Start:: Single Step Form Content -->
    <div class="table_title_wrapper">
      <div class="title_text_wrapper">
        <h5 style="color: #266db0">{{ $t("SIDENAV.settings.general") }}</h5>
      </div>
      <div class="col-12 text-end">
        <v-btn @click="$router.go(-1)" style="color: #266db0">
          <i class="fas fa-backward"></i>
        </v-btn>
      </div>
    </div>
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Search Radius Input -->
          <base-input
            type="number"
            col="6"
            :placeholder="`${$t('PLACEHOLDERS.search_radius_km')}`"
            v-model.trim="data.search_radius"
            required
          />
          <!-- End:: Search Radius Input -->

          <!-- Start:: Search Radius Input -->
          <base-input
            type="number"
            col="6"
            :placeholder="`${$t(
              'PLACEHOLDERS.subscription_renewal_reminder_period'
            )}`"
            v-model.trim="data.subscription_renewal_reminder_period"
            required
          />
          <!-- End:: Search Radius Input -->

          <!-- Start:: Search Radius Input -->
          <base-input
            type="number"
            col="6"
            :placeholder="`${$t('PLACEHOLDERS.min_provider_wallet')}`"
            v-model.trim="data.min_provider_wallet"
            required
          />
          <!-- End:: Search Radius Input -->

          <!-- Start:: Search Radius Input -->
          <base-input
            type="number"
            col="6"
            :placeholder="`${$t('PLACEHOLDERS.min_driver_wallet')}`"
            v-model.trim="data.min_driver_wallet"
            required
          />
          <!-- End:: Search Radius Input -->

          <!-- End:: Search Radius Input -->

          <!-- Start:: order_expiry_time_delivery_agents Input -->
          <base-input
            type="number"
            col="6"
            :placeholder="`${$t(
              'PLACEHOLDERS.order_expiry_time_delivery_agents'
            )}`"
            v-model.trim="data.order_expiry_time_delivery_agents"
            required
          />
          <!-- End:: order_expiry_time_delivery_agents Input -->

          <!-- Start:: delivery_price_per_km Input -->
          <base-input
            type="number"
            col="6"
            :step="0.01"
            :placeholder="`${$t('PLACEHOLDERS.delivery_price_per_km')}`"
            v-model.trim="data.delivery_price_per_km"
            required
          />
          <!-- End:: delivery_price_per_km Input -->

          <!-- Start:: tax_percentage Input -->
          <base-input
            type="number"
            col="6"
            :step="0.01"
            :placeholder="`${$t('PLACEHOLDERS.tax_percentage')}`"
            v-model.trim="data.tax_percentage"
            required
          />
          <!-- End:: tax_percentage Input -->

          <!-- Start:: service_provider_commission Input -->
          <base-input
            type="number"
            col="6"
            :step="0.01"
            :placeholder="`${$t('PLACEHOLDERS.service_provider_commission')}`"
            v-model.trim="data.service_provider_commission"
            required
          />
          <!-- End:: service_provider_commission Input -->

          <!-- Start:: delivery_agent_commission Input -->
          <base-input
            type="number"
            col="6"
            :step="0.01"
            :placeholder="`${$t('PLACEHOLDERS.delivery_agent_commission')}`"
            v-model.trim="data.admin_commission_on_driver"
            required
          />
          <!-- End:: delivery_agent_commission Input -->

          <!-- Start:: cancellation_time_limit Input -->
          <base-input
            type="number"
            col="6"
            :placeholder="`${$t('PLACEHOLDERS.cancellation_time_limit')}`"
            v-model.trim="data.time_limit_for_cancel_order"
            required
          />
          <!-- End:: cancellation_time_limit Input -->

          <!-- <template>
            <div class="mt-5">
              <label class="form-label fw-bold d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  v-model="data.money_transfer"
                  :true-value="1"
                  :false-value="0"
                />
                {{ $t("PLACEHOLDERS.money_transfer") }}
              </label>
            </div>
          </template> -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AppSetting",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data
      data: {
        subscription_renewal_reminder_period: null,
        search_radius: null,
        min_provider_wallet: null,
        min_driver_wallet: null,
        delivery_price_per_km: null,
        tax_percentage: null,
        order_expiry_time_delivery_agents: null,
        service_provider_commission: null,
        admin_commission_on_driver: null,
        time_limit_for_cancel_order: null,
        time_limit_for_resend_order: null,
        // money_transfer: null, // Default to 1 (true)
      },
      // End:: Data
    };
  },

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      getAuthenticatedUserData: "AuthenticationModule/getAuthenticatedUserData",
    }),
    // End:: Vuex Getters
  },

  methods: {
    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `settings`,
        });
        this.data.search_radius = res.data.data.data.find(
          (item) => item.key === "general"
        )?.value.radius_search;

        this.data.min_provider_wallet = res.data.data.data.find(
          (item) => item.key === "general"
        )?.value.acceptance_limit_for_providers;

        this.data.min_driver_wallet = res.data.data.data.find(
          (item) => item.key === "general"
        )?.value.acceptance_limit_for_driver;

        this.data.delivery_price_per_km = res.data.data.data.find(
          (item) => item.key === "general"
        )?.value.delivery_price_per_km;

        this.data.order_expiry_time_delivery_agents = res.data.data.data.find(
          (item) => item.key === "general"
        )?.value.order_expiry_time_delivery_agents;

        this.data.service_provider_commission = res.data.data.data.find(
          (item) => item.key === "general"
        )?.value.admin_commission_on_provider;

        this.data.admin_commission_on_driver = res.data.data.data.find(
          (item) => item.key === "general"
        )?.value.admin_commission_on_driver;

        this.data.time_limit_for_cancel_order = res.data.data.data.find(
          (item) => item.key === "general"
        )?.value.time_limit_for_cancel_order;

        this.data.subscription_renewal_reminder_period =
          res.data.data.data.find(
            (item) => item.key === "general"
          )?.value.subscription_renewal_reminder_period;

        this.data.tax_percentage = res.data.data.data.find(
          (item) => item.key === "general"
        )?.value.tax;

        // this.data.money_transfer = res.data.data.data.find(
        //   (item) => item.key === "general"
        // )?.value.money_transfer;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Edit

    // Start:: Submit Form
    async submitForm() {
      console.log("yes");
      this.isWaitingRequest = true;

      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("key", "general");
      if (this.data.search_radius) {
        REQUEST_DATA.append("value[radius_search]", this.data.search_radius);
      }

      if (this.data.min_driver_wallet) {
        REQUEST_DATA.append(
          "value[acceptance_limit_for_driver]",
          this.data.min_driver_wallet
        );
      }

      if (this.data.min_provider_wallet) {
        REQUEST_DATA.append(
          "value[acceptance_limit_for_providers]",
          this.data.min_provider_wallet
        );
      }

      if (this.data.delivery_price_per_km) {
        REQUEST_DATA.append(
          "value[delivery_price_per_km]",
          this.data.delivery_price_per_km
        );
      }

      if (this.data.order_expiry_time_delivery_agents) {
        REQUEST_DATA.append(
          "value[order_expiry_time_delivery_agents]",
          this.data.order_expiry_time_delivery_agents
        );
      }

      if (this.data.service_provider_commission) {
        REQUEST_DATA.append(
          "value[admin_commission_on_provider]",
          this.data.service_provider_commission
        );
      }

      if (this.data.admin_commission_on_driver) {
        REQUEST_DATA.append(
          "value[admin_commission_on_driver]",
          this.data.admin_commission_on_driver
        );
      }

      if (this.data.time_limit_for_cancel_order) {
        REQUEST_DATA.append(
          "value[time_limit_for_cancel_order]",
          this.data.time_limit_for_cancel_order
        );
      }

      if (this.data.subscription_renewal_reminder_period) {
        REQUEST_DATA.append(
          "value[subscription_renewal_reminder_period]",
          this.data.subscription_renewal_reminder_period
        );
      }

      if (this.data.tax_percentage) {
        REQUEST_DATA.append("value[tax]", this.data.tax_percentage);
      }

      // if (this.data.money_transfer !== null) {
      //   REQUEST_DATA.append("value[money_transfer]", this.data.money_transfer);
      // }

      // if (this.data.time_limit_for_resend_order) {
      // REQUEST_DATA.append("value[time_limit_for_resend_order]",this.data.time_limit_for_resend_order);
      // }

      try {
        await this.$axios({
          method: "POST",
          url: `settings`,
          data: REQUEST_DATA,
        });

        // console.log("money transfer", this.data.money_transfer);

        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.tax_percentage) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.tax"));
        return;
      } else if (
        this.data.tax_percentage < 0 ||
        this.data.tax_percentage > 100
      ) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.tax_min"));
        return;
      } else if (!this.data.search_radius) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.search_range"));
        return;
      } else if (this.data.search_radius < 0) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.search_range_min"));
        return;
      } else if (
        this.data.service_provider_commission < 0 ||
        this.data.service_provider_commission > 100
      ) {
        this.isWaitingRequest = false;
        this.$message.error(
          this.$t("VALIDATION.service_provider_commission_min")
        );
        return;
      } else if (!this.data.service_provider_commission) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.service_provider_commission"));
        return;
      } else if (!this.data.min_provider_wallet) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.min_provider_wallet"));
        return;
      } else if (!this.data.min_driver_wallet) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.min_driver_wallet"));
        return;
      } else if (!this.data.subscription_renewal_reminder_period) {
        this.isWaitingRequest = false;
        this.$message.error(
          this.$t("VALIDATION.subscription_renewal_reminder_period")
        );
        return;
      } else if (this.data.subscription_renewal_reminder_period < 0) {
        this.isWaitingRequest = false;
        this.$message.error(
          this.$t("VALIDATION.subscription_renewal_reminder_period_min")
        );
        return;
      } else if (!this.data.admin_commission_on_driver) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.delivery_agent_commission"));
        return;
      } else if (this.data.admin_commission_on_driver < 0) {
        this.isWaitingRequest = false;
        this.$message.error(
          this.$t("VALIDATION.delivery_agent_commission_min")
        );
        return;
      } else if (!this.data.delivery_price_per_km) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.delivery_price_per_km"));
        return;
      } else if (this.data.delivery_price_per_km < 0) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.delivery_price_per_km_min"));
      } else if (!this.data.order_expiry_time_delivery_agents) {
        this.isWaitingRequest = false;
        this.$message.error(
          this.$t("VALIDATION.order_expiry_time_delivery_agents")
        );
        return;
      } else if (this.data.order_expiry_time_delivery_agents < 0) {
        this.isWaitingRequest = false;
        this.$message.error(
          this.$t("VALIDATION.order_expiry_time_delivery_agents_min")
        );
        return;
      } else if (!this.data.time_limit_for_cancel_order) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.time_limit_for_cancel_order"));
        return;
      } else if (this.data.time_limit_for_cancel_order < 0) {
        this.isWaitingRequest = false;
        this.$message.error(
          this.$t("VALIDATION.time_limit_for_cancel_order_min")
        );
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs
  },

  created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>

<style>
.app_settings_class form .input_wrapper.top_label .form-label {
  font-size: 14px !important;
  top: -10px !important;
}

@media (max-width: 1080px) {
  .app_settings_class form .input_wrapper.top_label .form-label {
    font-size: 13px !important;
    top: -10px !important;
  }

  .app_settings_class form .input_wrapper.top_label input,
  .app_settings_class
    form
    .input_wrapper.top_label.select_wrapper
    .multiselect
    .multiselect__tags {
    padding: 30px 12px !important;
  }
}
</style>

<style lang="scss" scoped>
.all_action {
  display: flex;
  gap: 15px;
}

.add_another {
  border: none;
  padding: 8px;
  width: 40px;
  height: 40px;
  border: 1px solid var(--light_gray_clr);
  border-radius: 50%;
  font-size: 18px;
  color: var(--light_gray_clr);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: auto;

  .fa-trash {
    color: #ff2159;
    cursor: pointer;
  }
}

form input[type="checkbox"] {
  width: 22px;
  height: 22px;
  accent-color: var(--main_theme_clr);
}
</style>
